import React from "react";

// assets
import MegaPhoneIcon from "src/assets/images/profile/megaphone.svg";
import ChevronDown from "src/assets/images/profile/chevron_down.svg";

import styles from "./styles.module.scss";

const Share = () => {
  return (
    <div className={styles.share__wrapper}>
      <img src={MegaPhoneIcon} alt="megaphone" className={styles.megaphone} />
      <p>Share the app</p>
      <div className={styles.circle}>
        <img src={ChevronDown} alt={"chevron down"} />
      </div>
    </div>
  );
};

export default Share;
